import { ChangeDetectorRef, OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { Subscription } from 'rxjs';
import { TranslationService } from '../language/translation.service';

@Pipe({
  name: 'translate',
  pure: false,
})
export class TranslatePipe implements PipeTransform, OnDestroy {
  private languageChangedSub: Subscription;
  private translationsSub: Subscription;
  private lastKey = '';
  private lastParamsJson = '';
  private lastValue = '';

  constructor(
    private translationService: TranslationService,
    private cdr: ChangeDetectorRef,
  ) {
    this.languageChangedSub = this.translationService.languageChanged$.subscribe(() => {
      this.lastValue = '';
      this.cdr.markForCheck();
    });
    this.translationsSub = this.translationService.translations$.subscribe(() => {
      this.lastValue = '';
      this.cdr.markForCheck();
    });
  }

  transform(
    key: string,
    params: { [key: string]: any } = {},
  ): string {
    if (!key) {
      return '';
    }

    const paramsJson = JSON.stringify(params || {});
    if (this.lastKey === key && this.lastParamsJson === paramsJson && this.lastValue) {
      return this.lastValue;
    }

    this.lastKey = key;
    this.lastParamsJson = paramsJson;
    this.lastValue = this.translationService.getText(key, params);

    return this.lastValue;
  }

  ngOnDestroy(): void {
    if (this.languageChangedSub) {
      this.languageChangedSub.unsubscribe();
    }
    if (this.translationsSub) {
      this.translationsSub.unsubscribe();
    }
  }
}
